import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=16ee263a&scoped=true&"
import script from "./ContactBox.vue?vue&type=script&lang=js&"
export * from "./ContactBox.vue?vue&type=script&lang=js&"
import style0 from "./ContactBox.vue?vue&type=style&index=0&id=16ee263a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ee263a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
